<div class="container container_type_main">
  <div class="subtitle mt-32 h2 text-center">{{ 'offer-page.title' | translate }}</div>
  <div class="paragraph" [innerHtml]="'offer-page.text' | translate"></div>
</div>
